<div class="container-xxl press-kit-wrapper">
  <div class="press-kit-inner">
    <div *ngIf="pressKit.mainImage" class="press-kit-stage">
      <mb-image [media]="pressKit.mainImage" mbParallax></mb-image>
      <span *ngIf="pressKit.fuelLabel" class="fuel-label copy-s" [innerHTML]="pressKit.fuelLabel"></span>
    </div>
    <mb-info *ngIf="preMedia" type="danger">
      <div class="article-section-container">
        <div class="info-headline-wrapper">
          <span class="mb-icon mb-icon-attention-circle"></span>
          <h2 class="info-headline h4">{{ 'EMBARGO_CONFIRM_SUBLINE' | translate }}</h2>
        </div>
        <div class="info-subline copy-xl">{{ 'PRE_MEDIA_EMBARGO_HEADLINE' | translate }}</div>
        <p *ngFor="let embargoDate of preMedia.formatted_datetimes">
          {{ embargoDate }}
        </p>
        <div *ngIf="preMedia.enable_calendar" class="ics-btn-wrapper">
          <div class="btn btn-plain" (click)="openIcsModal()">
            <div class="mb-icon mb-icon-download"></div>
            <span>{{ 'DOWNLOAD_ICS' | translate }}</span>
          </div>
        </div>
      </div>
    </mb-info>
    <div class="press-kit-content">
      <div class="press-kit-section-container press-kit-section" mbScrollSpy="PRESS_KIT">
        <h1 class="press-kit-headline">{{ pressKit.title }}</h1>
        <div class="press-kit-info-container">
          <div>
            <span class="press-kit-info-location">{{ pressKit.location }}</span>
            <span *ngIf="pressKit.displayDate && !preMedia"
              >, {{ pressKit.displayDate | localizedDate: 'longDate' }}</span
            >
          </div>
          <div class="press-kit-info-separator"></div>
          <div class="press-kit-info-bottom">
            <mb-meta-items
              [metaItems]="pressKit.metaItems"
              itemClass="btn btn-plain"
              (itemClicked)="scrollToAnchor($event)"
            ></mb-meta-items>
            <mb-action-container
              [buttonItems]="defaultActions"
              [resource]="pressKit"
              (actionClick)="actionClick.emit({ action: $event, resource: pressKit })"
            ></mb-action-container>
          </div>
        </div>
        <div *ngIf="pressKit.fuelLabel" class="fuel-labels">
          <span class="copy-s" [innerHTML]="pressKit.fuelLabel"></span>
        </div>
      </div>

      <div class="press-kit-section-container press-kit-section">
        <mb-expandable-copy [text]="pressKit.content"></mb-expandable-copy>
      </div>

      <div
        *ngIf="pressKit.articles.length"
        id="article_article_section"
        class="press-kit-section-container press-kit-section"
        mbScrollSpy="ARTICLES"
      >
        <div class="press-kit-section-headline-wrapper">
          <h2 class="press-kit-section-headline">
            {{ 'ARTICLES' | translate }}
            <div class="mb-badge-small">{{ pressKit.articles.length }}</div>
          </h2>
        </div>
        <div class="document-item-list">
          <mb-expandable-card-wrapper
            [showAll]="showAllPressKitArticles"
            (toggleWrapper)="onTogglePressKitArticlesWrapper($event)"
          >
            <mb-article-card
              *ngFor="let article of pressKit.articles"
              [article]="article"
              [actions]="defaultActions"
              (click)="goToPressArticlePage(article)"
            ></mb-article-card>
          </mb-expandable-card-wrapper>
        </div>
      </div>

      <div *ngIf="pressKit.imageCount" class="press-kit-section" id="article_image_section" mbScrollSpy="IMAGES">
        <div class="press-kit-section-container">
          <div class="press-kit-section-headline-wrapper">
            <h2 class="press-kit-section-headline">
              {{ 'IMAGES' | translate }}
              <div class="mb-badge-small">{{ pressKit.imageCount }}</div>
            </h2>
            <mb-action-container
              [buttonItems]="sectionActions"
              [resource]="pressKit.images"
              (actionClick)="actionClick.emit({ action: $event, resource: pressKit.images })"
            ></mb-action-container>
          </div>
        </div>
        <mb-article-gallery
          [items]="pressKit.images"
          [buttonItems]="defaultActions"
          (itemClicked)="openMediaGallery(pressKit.images, $event.index)"
          (itemActionClicked)="actionClick.emit({ action: $event.action, resource: $event.media })"
        ></mb-article-gallery>
      </div>

      <div *ngIf="pressKit.videoCount" id="article_video_section" mbScrollSpy="VIDEOS">
        <div class="press-kit-section-container">
          <div class="press-kit-section-headline-wrapper">
            <h2 class="press-kit-section-headline">
              {{ 'VIDEOS' | translate }}
              <div class="mb-badge-small">{{ pressKit.videoCount }}</div>
            </h2>

            <mb-action-container
              [buttonItems]="sectionActions"
              [resource]="pressKit.videos"
              (actionClick)="actionClick.emit({ action: $event, resource: pressKit.videos })"
            ></mb-action-container>
          </div>
        </div>
        <div class="press-kit-section">
          <mb-masonry-gallery
            [items]="pressKit.videos"
            [buttonItems]="defaultActions"
            (itemClicked)="openMediaGallery(pressKit.videos, $event.index)"
            (itemActionClicked)="actionClick.emit({ action: $event.action, resource: $event.media })"
          ></mb-masonry-gallery>
        </div>
      </div>

      <div
        *ngIf="pressKit.documentCount"
        class="press-kit-section-container press-kit-section"
        id="article_document_section"
        mbScrollSpy="DOCUMENTS"
      >
        <div class="press-kit-section-headline-wrapper">
          <h2 class="press-kit-section-headline">
            {{ 'DOCUMENTS' | translate }}
            <div class="mb-badge-small">{{ pressKit.documentCount }}</div>
          </h2>

          <mb-action-container
            [buttonItems]="sectionActions"
            [resource]="pressKit.documents"
            (actionClick)="actionClick.emit({ action: $event, resource: pressKit.documents })"
          ></mb-action-container>
        </div>
        <div class="document-item-list">
          <mb-document-card
            *ngFor="let document of pressKit.documents; let index = index"
            [document]="document"
            [actions]="defaultActions"
            (click)="openMediaGallery(pressKit.documents, index)"
            (actionClick)="actionClick.emit($event)"
          ></mb-document-card>
        </div>
      </div>
      <div
        *ngIf="pressKit.technicalDataCount"
        class="press-kit-section-container press-kit-section"
        id="article_technical_data_section"
        mbScrollSpy="TECHNICAL_DATAS"
      >
        <div class="press-kit-section-headline-wrapper">
          <h2 class="press-kit-section-headline">
            {{ 'TECHNICAL_DATAS' | translate }}
            <div class="mb-badge-small">{{ pressKit.technicalDataCount }}</div>
          </h2>

          <mb-action-container
            [buttonItems]="sectionActions"
            [resource]="pressKit.technicalDatas"
            (actionClick)="actionClick.emit({ action: $event, resource: pressKit.technicalDatas })"
          ></mb-action-container>
        </div>
        <div class="document-item-list">
          <mb-document-card
            *ngFor="let document of pressKit.technicalDatas; let index = index"
            [document]="document"
            [actions]="defaultActions"
            (click)="openMediaGallery(pressKit.technicalDatas, index)"
            (actionClick)="actionClick.emit($event)"
          ></mb-document-card>
        </div>
      </div>
      <div
        *ngIf="pressKit.audioCount"
        class="press-kit-section-container press-kit-section"
        id="article_audio_section"
        mbScrollSpy="AUDIOS"
      >
        <div class="press-kit-section-headline-wrapper">
          <h2 class="press-kit-section-headline">
            {{ 'AUDIOS' | translate }}
            <div class="mb-badge-small">{{ pressKit.audioCount }}</div>
          </h2>

          <mb-action-container
            [buttonItems]="sectionActions"
            [resource]="pressKit.audios"
            (actionClick)="actionClick.emit({ action: $event, resource: pressKit.audios })"
          ></mb-action-container>
        </div>
        <div class="audio-list">
          <mb-audio
            [actions]="defaultActions"
            *ngFor="let audio of pressKit.audios; let index = index"
            [media]="audio"
            #audioPlayer
            (click)="audioPlayer.pause(); openMediaGallery(pressKit.audios, index)"
            (actionClick)="actionClick.emit({ action: $event, resource: audio })"
          ></mb-audio>
        </div>
      </div>

      <div
        *ngIf="pressKit.contactPersons.length"
        class="press-kit-section-container press-kit-section"
        mbScrollSpy="PRESS_CONTACTS"
      >
        <div class="press-kit-section-headline-wrapper">
          <h2 class="press-kit-section-headline">
            {{ 'PRESS_CONTACTS' | translate }}
            <div class="mb-badge-small">{{ pressKit.contactPersons.length }}</div>
          </h2>
        </div>
        <div class="press-contact-item-list">
          <mb-contact-person-card
            class="light-card column-card"
            *ngFor="let person of pressKit.contactPersons"
            [hideMedia]="true"
            [fullname]="person.fullname"
            [position]="person.position"
            [email]="person.email"
            [phone]="person.phone"
          ></mb-contact-person-card>
        </div>
      </div>

      <div class="press-kit-section-container press-kit-section press-kit-button-hub-section">
        <mb-action-container
          class="large"
          [buttonItems]="pressKitActions"
          [resource]="pressKit"
          (actionClick)="actionClick.emit({ action: $event, resource: pressKit })"
        ></mb-action-container>
      </div>
    </div>
    <mb-article-status-bar
      [article]="pressKit"
      [title]="pressKit.title"
      [metaItems]="pressKit.metaItems"
      [buttonItems]="defaultActions"
      (metaItemClicked)="scrollToAnchor($event)"
    ></mb-article-status-bar>
  </div>
</div>
